import { Component, OnInit } from '@angular/core';
import { MDBModalRef, MDBModalService } from 'angular-bootstrap-md';
import { Router, ActivatedRoute, ParamMap, Params } from '@angular/router';
import { saveAs } from 'file-saver';

import { UtilitarioService } from 'src/app/service/utilitarios/utilitario.service';
import { MaeConstanciaService } from 'src/app/service/mae-constancia.service';
import { DetParticipanteService } from 'src/app/service/det-participante.service';
import { DetArchivoService } from 'src/app/service/det-archivo.service';
import { MaeTablaService } from 'src/app/service/mae-tabla.service';
import { MaeProcesoService } from 'src/app/service/mae-proceso.service';
import { GlobalVariablesService } from 'src/app/service/global-variables.service';

import { MaeConstanciaE,MaeConstanciaM } from 'src/app/model/mae-constancia-bean';
import { DetParticipanteE,DetParticipanteM } from 'src/app/model/det-participante-bean';
import { Mae_tabla_E } from 'src/app/model/mae_tabla_bean';
import { Response_dml_bean } from 'src/app/model/response-dml';
import { MatDialog } from "@angular/material/dialog";

import { DmlParticipanteComponent } from 'src/app/pagina-admin/dashboard/gestion-participante/dml-participante/dml-participante.component';
import { DmlCargarCsvComponent } from 'src/app/pagina-admin/dashboard/gestion-participante/dml-cargar-csv/dml-cargar-csv.component';
import { DmlParticipanteAVComponent } from 'src/app/pagina-admin/dashboard/gestion-participante/dml-participante-av/dml-participante-av.component';
import { DmlEnvioFirmaComponent } from 'src/app/pagina-admin/dashboard/gestion-participante/dml-envio-firma/dml-envio-firma.component';
import { DmlVisorDocumentoComponent } from 'src/app/pagina-admin/dashboard/gestion-participante/dml-visor-documento/dml-visor-documento.component';
import { ConfirmarsionoComponent } from 'src/app/comunes/confirmarsiono/confirmarsiono.component';

@Component({
  selector: 'app-gestion-participante',
  templateUrl: './gestion-participante.component.html',
  styleUrls: ['./gestion-participante.component.scss']
})
export class GestionParticipanteComponent implements OnInit {
  constructor(
  private route: ActivatedRoute,
  private modalService: MDBModalService,
  private maeConstanciaService:MaeConstanciaService,
  private utilitarioService:UtilitarioService,
  private detParticipanteService:DetParticipanteService,
  private maeTablaService:MaeTablaService,
  private maeProcesoService:MaeProcesoService,
  private detArchivoService:DetArchivoService,
  private globalVariablesService: GlobalVariablesService,
  private dialogo: MatDialog,
  ) { }

  id_usuario:String;
  // datos generales
  id_constancia:String;
  c_tipo:String;
  a_tipo:String;

  tipo_participante:String;
  nombre_constancia:String;
  titulo:String;

  //filtro
  txt_nombre:String = "";
  cboEstado:String = "0";
  cboCorreo:String = "-1";

  //modal
  modalRefParticipanteAVDml: MDBModalRef;
  modalRefParticipanteDml: MDBModalRef;
  modalRefEnvioFirmaDml: MDBModalRef;
  modalRefVisorDocumentoDml: MDBModalRef;
  modalRefCargarCsvDml: MDBModalRef;

  //documento
  maeConstanciaE = new MaeConstanciaE();
  listParticipantes = new Array<DetParticipanteM>();
  listParticipantesCompleto = new Array<DetParticipanteM>();
  listEstado= new Array<Mae_tabla_E>();


  page = 1;
  pageSize = 10;

  headElements = ['Nro','Nombre','Estado','Editar','Archivos','Generar','Enviar a Firma','Enviar Correo'];

  ngOnInit(): void {
    this.id_usuario= this.globalVariablesService.getC_usuario();

    //recuperar parametro
    this.route.params.subscribe((params: Params) => {
      //console.log(params);
      this.a_tipo = params['tipo'];
      this.id_constancia = params['id'];
      this.cargarDatoInicial();

    });
  }
  cargarDatoInicial(){

    if(this.a_tipo==='a')
    {
      this.c_tipo = '19';
      this.tipo_participante = "Alumno";
      this.titulo ='Gestion de Constancias de Alumnos';
    }
    else
    {
      this.c_tipo = '20';
      this.tipo_participante = "Profesor";
      this.titulo ='Gestion de Constancias de Profesores';
    }

    const cargarEstado = this.maeTablaService.getList("ESTADO").toPromise()
    .then(result => {
      this.listEstado = result;
    });

      this.utilitarioService.loading = true;
      const cargarConstancia = this.maeConstanciaService.get(this.id_constancia.toString()).toPromise()
      .then(result => {
        this.maeConstanciaE = result[0];
      });

      Promise.all([cargarConstancia,cargarEstado])
      .then(response => {
        this.nombre_constancia = this.maeConstanciaE.x_curso;
        this.onBuscar();
        this.utilitarioService.loading = false;
      });

  }

  onBuscar(){

    this.utilitarioService.loading = true;

    var nombre = "*";
    if(this.txt_nombre.toString().length>0)    nombre = this.txt_nombre.toString();

    console.log(this.cboCorreo);
    this.detParticipanteService.getfind(this.id_constancia.toString(),this.c_tipo.toString(),nombre,this.cboEstado.toString(),this.cboCorreo.toString()).subscribe(data=>{
      this.listParticipantes = data;
      this.listParticipantesCompleto = data;
      this.utilitarioService.loading = false;
    });

  }

  onChangeEstado()
  {
    if(this.cboEstado==="0")
      this.listParticipantes = this.listParticipantesCompleto;
    else
      this.listParticipantes = this.listParticipantesCompleto.filter(x=>x.c_estado===this.cboEstado );

  }

  onChangeCorreo()
  {
    //console.log(this.cboCorreo);
    if(this.cboCorreo==="-1")
      this.listParticipantes = this.listParticipantesCompleto;
    else
      this.listParticipantes = this.listParticipantesCompleto.filter(x=>x.l_envio_correo===this.cboCorreo );

  }

  onAgregarAV()
  {
    this.modalRefParticipanteAVDml = this.modalService.show(DmlParticipanteAVComponent,
      {
        backdrop: true,
        keyboard: true,
        focus: true,
        show: false,
        ignoreBackdropClick: false,
        class: 'modal-dialog modal-dialog-centered modal-dialog-scrollable modal-notify modal-warning modal-lg',
        containerClass: 'top',
        animated: true,
        data: {
          id_curso: this.maeConstanciaE.c_curso,
          c_tipo : this.c_tipo,
          x_tipo:this.tipo_participante,
          id_constancia:this.id_constancia,
          //x_prefijo_constancia:this.maeConstanciaE.x_prefijo_nro
        }
      }
    );
    this.modalRefParticipanteAVDml.content.action.subscribe( (result: Response_dml_bean) =>
    {
      console.log(result);
      if (result.codigoRespuestaServicio=="1"){
        if(result.mensaje.length>0)
        this.utilitarioService.toastrSuccess(result.mensaje);
        this.onBuscar();
      }else{
        if(result.mensaje.length>0)
          this.utilitarioService.toastrInfo(result.mensaje);
      }

    });
  }

  onEditar(detParticipanteM:DetParticipanteM)
  {
    this.modalRefParticipanteDml = this.modalService.show(DmlParticipanteComponent,
    {
      backdrop: true,
      keyboard: true,
      focus: true,
      show: false,
      ignoreBackdropClick: false,
      class: 'modal-dialog modal-dialog-centered modal-dialog-scrollable modal-notify modal-warning modal-lg',
      containerClass: 'top',
      animated: true,
      data: {
        id: detParticipanteM.c_participante,
        x_titulo: 'Editar '+this.tipo_participante,
        c_tipo :this.c_tipo,
        id_constancia : this.id_constancia,
      }
    });
    this.modalRefParticipanteDml.content.action.subscribe( (result: Response_dml_bean) =>
    {
      if (result.codigoRespuestaServicio=="1"){
        this.utilitarioService.toastrSuccess(result.mensaje);
        this.onBuscar();
      }
    });
  }
  onNuevoParticipante()
  {
    this.modalRefParticipanteDml = this.modalService.show(DmlParticipanteComponent,
    {
      backdrop: true,
      keyboard: true,
      focus: true,
      show: false,
      ignoreBackdropClick: false,
      class: 'modal-dialog modal-dialog-centered modal-dialog-scrollable modal-notify modal-warning modal-lg',
      containerClass: 'top',
      animated: true,
      data: {
        id: 0,
        x_titulo: 'Nuevo '+this.tipo_participante,
        c_tipo :this.c_tipo,
        id_constancia : this.id_constancia,
      }
    });
    this.modalRefParticipanteDml.content.action.subscribe( (result: Response_dml_bean) =>
    {
      if (result.codigoRespuestaServicio=="1"){
        this.utilitarioService.toastrSuccess(result.mensaje);
        this.onBuscar();
      }
    });
  }
  onNuevosParticipanteCsv()
  {
    this.modalRefCargarCsvDml = this.modalService.show(DmlCargarCsvComponent,
    {
      backdrop: true,
      keyboard: true,
      focus: true,
      show: false,
      ignoreBackdropClick: false,
      class: 'modal-dialog modal-dialog-centered modal-dialog-scrollable modal-notify modal-warning modal-lg',
      containerClass: 'top',
      animated: true,
      data: {
        x_titulo: 'Carga Grupal '+this.tipo_participante,
        c_tipo :this.c_tipo,
        id_constancia : this.id_constancia,
        x_informacion:'Debe subir la lista de participantes en formato CSV, puede descargar la plantilla a continuación.',
      }
    });
    this.modalRefCargarCsvDml.content.action.subscribe( (result: Response_dml_bean) =>
    {
      if (result.codigoRespuestaServicio=="1"){
        this.utilitarioService.toastrSuccess(result.mensaje);
        this.onBuscar();
      }
    });
  }
  onVisualizarDocumento(parti:DetParticipanteM,firmado:number){
    this.modalRefVisorDocumentoDml = this.modalService.show(DmlVisorDocumentoComponent,
      {
        backdrop: true,
        keyboard: true,
        focus: true,
        show: false,
        ignoreBackdropClick: false,
        class: 'modal-dialog modal-dialog-centered modal-dialog-scrollable modal-notify modal-warning modal-lg',
        containerClass: 'top',
        animated: true,
        data: {
          x_titulo: this.maeConstanciaE.x_titulo+" de "+this.tipo_participante,
         // id_participante: '0',
          //id_constancia: this.id_constancia,
          esfirmado:firmado,
          x_uid: parti.x_uid_pdf,
          //x_informacion:'Se generará un word con todas plantillas que se encuentren en estado GENERADO.',
        }
      });
    }
  onDescargarArchivo(id:string,uid:string,ext:string){
    this.utilitarioService.loading = true;
    this.detArchivoService.getFile(uid).subscribe(blob=>{
      this.utilitarioService.loading = false;
      saveAs(blob,"plantilla_word_"+id+ext);
    });
  }
  onGenerar(detParticipanteM:DetParticipanteM)
  {
    this.dialogo.open(ConfirmarsionoComponent, {
      data: { mensaje: '¿Desea generar la plantilla para el participante seleccionado?.'},
      width: '550px'
    })
    .afterClosed()
    .subscribe((confirmado: Boolean) => {

      if (confirmado) {

          this.utilitarioService.loading = true;

        this.maeProcesoService.generar(detParticipanteM.c_participante.toString()).subscribe(result=>{
          if (result.codigoRespuestaServicio=="1")
          {
            this.utilitarioService.toastrSuccess(result.mensaje);
            detParticipanteM.c_estado = "22";
            detParticipanteM.x_estado = "GENERADO";
            detParticipanteM.x_uid_doc = result.codigoRegistroBD;

          }else{
            this.utilitarioService.toastrWarning(result.mensaje);
          };

          this.utilitarioService.loading = false;
        });

      } else {
        return;
      }
    });

  }
  onGenerarTodos()
  {
    console.log(this.cboEstado+", total:"+this.listParticipantes.length.toString()+",tipo"+this.c_tipo.toString());
    var consulta;

    if(this.cboEstado==='0')
      consulta='¿Desea continuar con la generacion de la plantilla para los participantes con estado REGISTRADO?. Se generará maximo 40 plantillas.';
    else
    {
      if(this.cboEstado==='21' || this.cboEstado==='22' || this.cboEstado==='23')
      {
        var estado =  this.listEstado.find(x=>x.c_tabla.toString()===this.cboEstado ).x_valor;
        consulta='¿Desea continuar con la generacion de la plantilla para los '+this.listParticipantes.length.toString()
              +' participante(s) con estado '+estado+'?.';
      }
      else
        consulta = '';
    }

    if(consulta.length>0)
    {
      this.dialogo.open(ConfirmarsionoComponent, {
        data: { mensaje: consulta},
        width: '550px'
      })
      .afterClosed()
      .subscribe((confirmado: Boolean) => {
          if (confirmado) {

            this.utilitarioService.loading = true;

          this.maeProcesoService.generartodos(this.id_constancia.toString(),this.c_tipo.toString(),this.cboEstado.toString()).subscribe(result=>{
            if (result.codigoRespuestaServicio=="1")
            {
              this.utilitarioService.toastrSuccess(result.mensaje);
              console.log(result.codigoRegistroBD);
              this.onBuscar();

            }else{
              this.utilitarioService.toastrError(result.mensaje);
            };

            this.utilitarioService.loading = false;
          });

        } else {
          return;
        }
      });
    }
    else
      this.utilitarioService.toastrInfo('No se puede generar para el estado seleccionado.');
  }


  onEnviarFirma(detParticipanteM:DetParticipanteM){
    this.modalRefEnvioFirmaDml = this.modalService.show(DmlEnvioFirmaComponent,
      {
        backdrop: true,
        keyboard: true,
        focus: true,
        show: false,
        ignoreBackdropClick: false,
        class: 'modal-dialog modal-dialog-centered modal-dialog-scrollable modal-notify modal-warning modal-lg',
        containerClass: 'top',
        animated: true,
        data: {
          x_titulo: 'Verificar plantilla y enviar a Firma',
          id_participante: detParticipanteM.c_participante,
          id_constancia: this.id_constancia,
          x_uid: detParticipanteM.x_uid_doc,
          x_informacion:detParticipanteM.x_nombres,
        }
      });
      this.modalRefEnvioFirmaDml.content.action.subscribe( (result: Response_dml_bean) =>
      {
        console.log(result);
        if (result.codigoRespuestaServicio=="1"){
          if(result.mensaje.length>0)
          this.utilitarioService.toastrSuccess(result.mensaje);
          this.onBuscar();
        }else{
          if(result.mensaje.length>0)
            this.utilitarioService.toastrInfo(result.mensaje);
        }

      });
  }
  onEnviarFirmaTodos(){
    this.modalRefEnvioFirmaDml = this.modalService.show(DmlEnvioFirmaComponent,
      {
        backdrop: true,
        keyboard: true,
        focus: true,
        show: false,
        ignoreBackdropClick: false,
        class: 'modal-dialog modal-dialog-centered modal-dialog-scrollable modal-notify modal-warning modal-lg',
        containerClass: 'top',
        animated: true,
        data: {
          x_titulo: 'Verificar plantillas y enviar a Firmar',
          id_participante: '0',
          id_constancia: this.id_constancia,
          x_uid: '',
          x_informacion:'Se generará un word con máximo 40 plantillas que se encuentren en estado GENERADO.',
        }
      });
      this.modalRefEnvioFirmaDml.content.action.subscribe( (result: Response_dml_bean) =>
      {
        console.log(result);
        if (result.codigoRespuestaServicio=="1"){
          if(result.mensaje.length>0)
          this.utilitarioService.toastrSuccess(result.mensaje);
          this.onBuscar();
        }else{
          if(result.mensaje.length>0)
            this.utilitarioService.toastrInfo(result.mensaje);
        }

      });
  }
  onEnviarCorreo(detParticipanteM:DetParticipanteM)
  {
    //this.utilitarioService.toastrInfo('En este entorno de pruebas, esta opcion se encuentra deshabilitada, para probar utilice el mantenimiento de correo');



    var consulta;

    if(detParticipanteM.l_envio_correo==='0')
      consulta='¿Desea enviar el correo al participante seleccionado?';
    else
      consulta='El correo ya fue enviado. ¿Desea volver a enviar el correo al participante seleccionado?';

    this.dialogo.open(ConfirmarsionoComponent, {
      data: { mensaje: consulta}, // +'. Para realizar las pruebas cualquier correo sera enviado a: elizabeth.alberco@bnp.gob.pe'
      width: '550px'
    })
    .afterClosed()
    .subscribe((confirmado: Boolean) => {
        if (confirmado) {

          this.utilitarioService.loading = true;

        this.maeProcesoService.enviarcorreo(this.id_constancia.toString(),detParticipanteM.c_participante.toString()).subscribe(result=>{
          if (result.codigoRespuestaServicio=="1")
          {
            this.utilitarioService.toastrSuccess(result.mensaje);
            console.log(result.codigoRegistroBD);
            this.onBuscar();

          }else{
            this.utilitarioService.toastrInfo(result.mensaje);
          };

          this.utilitarioService.loading = false;
        });

      } else {
        return;
      }
    });
  }

  onEnviarCorreoTodos()
  {
    //this.utilitarioService.toastrInfo('En este entorno de pruebas, esta opcion se encuentra deshabilitada');

    this.dialogo.open(ConfirmarsionoComponent, {
      data: { mensaje: 'Se enviara correo a un grupo máximo de 10 participantes que esten en estado FIRMADO y no se les haya enviado aun correo.'},
      width: '550px'
    })
    .afterClosed()
    .subscribe((confirmado: Boolean) => {
        if (confirmado) {

          this.utilitarioService.loading = true;

        this.maeProcesoService.enviarcorreo(this.id_constancia.toString(),'0').subscribe(result=>{
          if (result.codigoRespuestaServicio=="1")
          {
            this.utilitarioService.toastrSuccess(result.mensaje);
            console.log(result.codigoRegistroBD);
            this.onBuscar();

          }else{
            this.utilitarioService.toastrInfo(result.mensaje);
          };

          this.utilitarioService.loading = false;
        });

      } else {
        return;
      }
    });


    }

    onEliminarTodos()
    {

      var listprevia = this.listParticipantesCompleto.filter(x=>x.c_estado==='21' || x.c_estado==='22' );

      if(listprevia.length>0)
      this.dialogo.open(ConfirmarsionoComponent, {
        data: { mensaje: 'Se eliminará todos los alumnos que esten en estado REGISTRADO o GENEARDO. ¿Desea continuar?'},
        width: '550px'
      })
      .afterClosed()
      .subscribe((confirmado: Boolean) => {
          if (confirmado) {

            this.utilitarioService.loading = true;


            var listaaux = this.listParticipantesCompleto.filter(x=>x.c_estado==='21' || x.c_estado==='22' );

            var i:number;
            var cont_respondidos = 0;
            var cont_eliminados = 0;
            for(i = 0;i<listaaux.length;i++) {

                  var id_parti = listaaux[i].c_participante;

                  this.detParticipanteService.delete(id_parti.toString()).subscribe( (response_dml_bean : Response_dml_bean) => {
                    cont_respondidos++;
                  if (response_dml_bean.codigoRespuestaServicio=="1")
                    cont_eliminados++;
                  else
                    this.utilitarioService.toastrError(response_dml_bean.mensaje);

                    if(cont_respondidos == listaaux.length)
                    {
                      this.utilitarioService.loading = false;
                      this.utilitarioService.toastrSuccess("Se elimino " +cont_eliminados.toString()+ " participante(s) en estado REGISTRADO.");
                      this.onBuscar();
                    }
                },
                error=>{
                  this.utilitarioService.toastrError("Hubo un error al eliminar el participante." + error.error.messages.toString());
                  cont_respondidos++;
                  if(cont_respondidos == listaaux.length)
                    {
                      this.utilitarioService.loading = false;
                      this.utilitarioService.toastrSuccess("Se elimino " +cont_eliminados.toString()+ " participante(s) en estado REGISTRADO.");
                      this.onBuscar();
                    }
                });
          }
        } else {
          return;
        }
      });
      else
      this.utilitarioService.toastrSuccess("No existe participantes en estado REGISTRADO o GENERADO para eliminar.");
    }
  }
